import {Tooltip} from "@mui/material";
import {Check} from "@mui/icons-material";
import * as React from "react";

const AttendanceVerifiedIcon = ({person}) => {
    return (
        <>
            {
                person?.hasOwnProperty("attendance_verified") && person.attendance_verified === 1 &&
                <Tooltip title="Attendance Verified">
                    <Check sx={{color: "black", fontSize: '20px'}}/>
                </Tooltip>
            }
        </>
    )
}

export default AttendanceVerifiedIcon;